"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    region: "AI-POWERED",
    name: "AI Threat Detection",
    age: "Real-time Analysis",
    notes: ["ML-MODELS", "BEHAVIORAL", "AUTOMATED"],
    price: "SECURE",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/ai_threat_detection.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/ai_threat_detection.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/ai_threat_detection.webp-wvc-sizes"
  }, {
    region: "24/7 OPERATIONS",
    name: "Security Monitoring",
    age: "Continuous Oversight",
    notes: ["SOC-TEAM", "ALERTS", "RESPONSE"],
    price: "ACTIVE",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_monitoring.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_monitoring.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_monitoring.webp-wvc-sizes"
  }, {
    region: "DEFENSE",
    name: "Phishing Prevention",
    age: "Email Security",
    notes: ["FILTERING", "SANDBOX", "PROTECTION"],
    price: "SHIELD",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/phishing_prevention.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/phishing_prevention.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/phishing_prevention.png-wvc-sizes"
  }, {
    region: "ASSESSMENT",
    name: "Vulnerability Scans",
    age: "System Audits",
    notes: ["PATCHING", "TESTING", "REMEDIATION"],
    price: "STABLE",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/vulnerability_assessment.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/vulnerability_assessment.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/vulnerability_assessment.png-wvc-sizes"
  }, {
    region: "EDUCATION",
    name: "Security Awareness",
    age: "Employee Training",
    notes: ["SIMULATIONS", "WORKSHOPS", "CULTURE"],
    price: "AWARE",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_training.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_training.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_training.webp-wvc-sizes"
  }, {
    region: "CRITICAL",
    name: "Incident Response",
    age: "Rapid Recovery",
    notes: ["FORENSICS", "CONTAINMENT", "RECOVERY"],
    price: "READY",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/incident_response.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/incident_response.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/incident_response.png-wvc-sizes"
  }, {
    region: "STRATEGY",
    name: "Security Consulting",
    age: "Expert Guidance",
    notes: ["ARCHITECTURE", "POLICY", "DESIGN"],
    price: "EXPERT",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_consulting.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_consulting.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_consulting.png-wvc-sizes"
  }, {
    region: "COMPLIANCE",
    name: "Risk & Compliance",
    age: "Regulatory Support",
    notes: ["GDPR", "ISO", "AUDITS"],
    price: "VERIFIED",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/risk_compliance.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/risk_compliance.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/risk_compliance.png-wvc-sizes"
  }, {
    region: "SCALABLE",
    name: "Business Protection",
    age: "Enterprise Security",
    notes: ["CLOUD", "NETWORK", "ENDPOINT"],
    price: "SCALED",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/business_protection.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/business_protection.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/business_protection.webp-wvc-sizes"
  }];
  return <section data-section-id="2747" id="servicedetail" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-xs tracking-[0.3em] mb-8 text-primary">
            OUR EXPERTISE / CYBERSECURITY SOLUTIONS
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] max-w-3xl mx-auto">
            Advanced AI-Powered Protection for Your Business.
          </h2>
        </div>

        <div ref={gridRef} className={`mt-20 md:mt-24 lg:mt-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {services.map((service, i) => <Card key={i} data-index={i} className="group bg-card rounded-lg p-10 gap-0 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-lg border border-border">
              <div className="relative overflow-hidden rounded-lg mb-8 bg-gradient-to-br from-blue-500 to-cyan-500" style={{
            aspectRatio: "4 / 5"
          }}>
                <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.name} loading="lazy" decoding="async" className="relative w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] opacity-90" />
              </div>

              <CardContent className="px-0">
                <p className="font-default text-[10px] tracking-[0.25em] mb-4 text-primary font-semibold">
                  {service.region}
                </p>
                <h3 className="font-default text-2xl md:text-[1.75rem] font-bold leading-tight mb-2">
                  {service.name}
                </h3>
                <p className="font-default text-base mb-6 text-muted-foreground">
                  {service.age}
                </p>

                <div className="h-px w-full mb-6 bg-border" />

                <div className="flex flex-wrap gap-2 mb-8">
                  {service.notes.map((note, j) => <span key={j} data-index={j} className="inline-flex items-center px-3 py-1.5 rounded-md border text-[10px] font-default tracking-[0.2em] border-border text-muted-foreground">
                      {note}
                    </span>)}
                </div>

                <div className="flex items-center justify-end">
                  <p className="font-default text-sm font-bold tracking-wider text-primary">
                    STATUS — {service.price}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div ref={ctaRef} className={`mt-20 md:mt-24 text-center transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild variant="link" className="group font-default text-xs tracking-[0.3em] p-0 h-auto hover:no-underline text-primary">
            <Link to="/ContactPage">
              <span className="relative inline-block">
                REQUEST A FREE SECURITY ASSESSMENT
                <span className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-0 bg-primary" />
                <span className="absolute left-0 -bottom-1 h-px w-full origin-right scale-x-0 transition-transform duration-500 delay-150 group-hover:scale-x-100 bg-primary" />
              </span>
              <ArrowRight className="ml-2 size-3 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}